import { render, staticRenderFns } from "./SparePartsDetail.vue?vue&type=template&id=c8f1aca2&scoped=true&"
import script from "./SparePartsDetail.vue?vue&type=script&lang=js&"
export * from "./SparePartsDetail.vue?vue&type=script&lang=js&"
import style0 from "./SparePartsDetail.vue?vue&type=style&index=0&id=c8f1aca2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f1aca2",
  null
  
)

export default component.exports